// jQuery
global.jQuery = require('jquery');
global.$ = global.jQuery;

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.wheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("wheel", handle, {passive: true});
    }
};
jQuery.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("mousewheel", handle, {passive: true});
    }
};


$(function () {

    let app = require('./modules/core')();
    app.initBootstrap();
    app.initLazyLoad();
    //app.initLightbox(); // Use Spotlight for galleries - comment this in if you need it
    app.initSlickCarousel();
    app.scrollToAnchor();
    app.scrollToAccordionItem();
    app.detectUrlScrollHash();
    app.convertCryptedEmails();
    app.initMobileMenu();
    app.initRrssb();
    app.initPopups();
    app.initSpotlightJs();
    app.initTingleModalJs();

    //app.navDropdownHover(); // Hover instead of click on Nav dropdowns
    //app.initDatePicker();
    app.initWowJs();
    app.initStickyEl();
    app.keepTokenAlive();
    //app.initTooltips();
    app.announcementBarDismiss();
    app.chevronToggle();

    let googleMaps = require('./modules/google-maps')();
    googleMaps.assign();


    $(".megamenu").on("click", function (e) {
        e.stopPropagation();
    });

    $('.see-more').click(function(){
        $(this).parent('.tags').find('.badge').removeClass('d-none');
        $(this).hide();
    });

    // Search form submission
    $(document).on('submit', '#consultant-search-form', function (e) {
        e.preventDefault();

        const form = $(this);

        if (form.closest('.hero-container').length > 0) {
            const formData = form.serialize();
            const baseUrl = form.data('url') || window.location.pathname; // fallback to current path
            const newUrl = `${baseUrl}?${formData}`;
            window.location.href = newUrl; // Redirect
            return;
        }

        // Original logic
        const formData = form.serialize();
        const baseUrl = new URL(window.location.href);
        const newUrl = `${baseUrl.pathname}?${formData}`;

        window.history.pushState({}, '', newUrl);
        console.log('Updated URL:', newUrl);

        updateConsultantsResults(newUrl);
    });


    // Availability checkbox change
    $(document).on('change', '#availability input[type="checkbox"]', function () {
        const availableChecked = $('#availability input[name="available"]').is(':checked');
        const unavailableChecked = $('#availability input[name="unavailable"]').is(':checked');

        const name = $(this).attr('name');
        const selected = $(this).is(':checked');

        let baseUrl = new URL(window.location.href);
        let params = new URLSearchParams(baseUrl.search);
        let urlSet = false;
        let newUrl = `${baseUrl.pathname}?`;

        if ((availableChecked && unavailableChecked) || (!availableChecked && !unavailableChecked)) {
            params.delete('available');
        } else if (availableChecked) {
            params.set('available', true);
            urlSet = true;

        } else if (unavailableChecked) {
            params.set('available', false);
            urlSet = true;

        }

        // If both checkboxes are checked, do nothing
        if (urlSet) newUrl = `${baseUrl.pathname}?${params.toString()}`;

        window.history.pushState({}, '', newUrl);
        console.log('Updated URL:', newUrl);

        updateConsultantsResults(newUrl);
    });

    $(document).on('change', '#companies .company input[type="checkbox"]', function () {
        const baseUrl = new URL(window.location.href);
        const params = new URLSearchParams(baseUrl.search);

        // Get all selected regions
        const selectedCompanies = $('#companies .company input[type="checkbox"]:checked').map(function () {
            return $(this).closest('.company').data('id');
        }).get();

        // Update 'region' param with comma-separated list or remove it
        if (selectedCompanies.length > 0) {
            params.set('company_id', selectedCompanies.join(','));
        } else {
            params.delete('company_id');
        }

        const newUrl = `${baseUrl.pathname}?${params.toString()}`;
        window.history.pushState({}, '', newUrl);
        console.log('Updated URL:', newUrl);

        updateConsultantsResults(newUrl);
    });

    $(document).on('change', '#regions .region input[type="checkbox"]', function () {
        const baseUrl = new URL(window.location.href);
        const params = new URLSearchParams(baseUrl.search);

        // Get all selected regions
        const selectedRegions = $('#regions .region input[type="checkbox"]:checked').map(function () {
            return $(this).closest('.region').data('region');
        }).get();

        // Update 'region' param with comma-separated list or remove it
        if (selectedRegions.length > 0) {
            params.set('region', selectedRegions.join(','));
        } else {
            params.delete('region');
        }

        const newUrl = `${baseUrl.pathname}?${params.toString()}`;
        window.history.pushState({}, '', newUrl);
        console.log('Updated URL:', newUrl);

        updateConsultantsResults(newUrl);
    });


// Specialization checkbox change
    $(document).on('change', '#specializations .specialization input[type="checkbox"]', function () {
        const id = $(this).closest('.specialization').data('id').toString();
        const baseUrl = new URL(window.location.href);
        const params = new URLSearchParams(baseUrl.search);

        let current = params.get('specializations');
        let specializationList = current ? current.split(',') : [];

        if ($(this).is(':checked')) {
            if (!specializationList.includes(id)) {
                specializationList.push(id);
            }
        } else {
            specializationList = specializationList.filter(item => item !== id);
        }

        if (specializationList.length > 0) {
            params.set('specializations', specializationList.join(','));
        } else {
            params.delete('specializations');
        }

        const newUrl = `${baseUrl.pathname}?${params.toString()}`;
        window.history.pushState({}, '', newUrl);
        console.log('Updated URL:', newUrl);

        updateConsultantsResults(newUrl);
    });


    // Function to perform the AJAX request and update the entire page
    function updateConsultantsResults(url) {
        document.body.classList.add('loading');

        $.ajax({
            url: '/consultants/ajax',
            method: 'POST',
            data: {'url': url},
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            cache: true,
            success: function (response) {
                console.log(response);

                // Update filters + results
                $('.filters-container').html(response.filters_html);
                $('.results-container').html(response.results_html);

                document.body.classList.remove('loading');
                app.scrollToElement('.members');
            },

            error: function (xhr, status, error) {
                console.error('Error fetching results:', error);
                document.body.classList.remove('loading');

            }
        });
    }


    document.querySelector('.back-to-top').addEventListener('click', () => {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reducedMotion ? 'instant' : 'smooth' });
    });


    document.addEventListener("DOMContentLoaded", function () {

        const stackItems = document.querySelectorAll('.stack-item');

        // Breathing room in px. Bump to 200 if 100 isn't enough.
        const OFFSET = 100;

        const adjustStickyOffsets = () => {
            const viewportHeight = window.innerHeight;

            stackItems.forEach(item => {
                const itemHeight = item.offsetHeight;

                if (itemHeight + OFFSET > viewportHeight) {
                    // Taller than screen: bottom of card sits OFFSET above the viewport bottom
                    const diff = itemHeight - viewportHeight + OFFSET;
                    item.style.top = `-${diff}px`;
                } else {
                    // Shorter than screen: sits OFFSET down from the viewport top
                    item.style.top = `${OFFSET}px`;
                }
            });
        };

        adjustStickyOffsets();
        window.addEventListener('resize', adjustStickyOffsets);

        const observer = new ResizeObserver(adjustStickyOffsets);
        stackItems.forEach(item => observer.observe(item));
    });


});
